import { render, staticRenderFns } from "./FerryPickupDetail.vue?vue&type=template&id=52f365f6"
import script from "../../controllers/ferry_pickup/ferry-pickup-detail.js?vue&type=script&lang=js&external"
export * from "../../controllers/ferry_pickup/ferry-pickup-detail.js?vue&type=script&lang=js&external"
import style0 from "./FerryPickupDetail.vue?vue&type=style&index=0&id=52f365f6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports